const STORAGE = {
  user: '_mz_usr_',
  token: '_mz_tkn_',
  order: '_mz_ord_',
};

export default STORAGE;
